import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import moment from 'moment';
import Logo from '../../assets/images/conciliationSeal/Logo.png'
import Check from '../../assets/images/conciliationSeal/Check.png'

const styles = StyleSheet.create({
	header: {
		height: '80px',
		width: '100%',
		backgroundColor: '#303030',
		alignItems: 'center',
		justifyContent: 'center'
	},

	body: {
		flexDirection: 'column',
		color: '303030',
		alignItems: 'center',
		fontSize: 14,
		display: 'flex',
		minHeight: '100%'

	},

	footer: {
		color: '#fff',
		height: '120px',
		backgroundColor: '#303030',
		width: '100%'
	},

	spanFooter: {
		paddingVertical: '35px',
		paddingHorizontal: '30px'
	},

	textFooter: {
		fontSize: 15
	},

	logo: {
		width: '234px',
		height: '30px'
	},

	container: {
		paddingTop: '5px',
		width: '500px',
		margin: '0 auto',
		flexGrow: 1,
		flex: 1
	},

	check: {
		height: '110px',
		width: '110px',
	},

	checkContainer: {
		paddingTop: '50px',
		alignItems: 'center',
	},

	h2: {
		textAlign: 'center',
		fontWeight: 'bold',
		fontSize: 17,
		paddingBottom: '25px'

	},

	row: {
		textAlign: 'center',
		flexDirection: 'row',
	},

	colType1: {
		height: '31px',
		justifyContent: 'center',
		flex: 1,
		margin: '3px',
		backgroundColor: '#dddddd'
	},

	colType2: {
		height: '31px',
		justifyContent: 'center',
		flex: 1,
		margin: '3px',
		backgroundColor: '#f2f2f2'
	},

	tableHeader: {
		height: '33px',
		justifyContent: 'center',
		flex: 1,
		margin: '3px',
		backgroundColor: '#c4c4c4',
		borderTopLeftRadius: '10',
		borderTopRightRadius: '10',

	},

	tableFooter: {
		justifyContent: 'center',
		flex: 1,
		margin: '3px',
		backgroundColor: '#f2f2f2',
		borderBottomLeftRadius: '10',
		borderBottomRightRadius: '10',

	},

	fornecedor: {
		padding: '15px'
	}
});
const ConciliationSeal = (props) => (
	<Document>
		<Page size="A4">
			<View style={styles.body}>
				<View style={styles.header}>
					<Image
						style={styles.logo}
						src={Logo}
					/>
				</View>
				<View style={styles.checkContainer}>
					<Image
						style={styles.check}
						src={Check}
					/>
				</View>
				<View style={styles.container}>
					<Text style={styles.h2}>
						Aprovado!
					</Text>
					<View style={styles.row}>
						<View style={styles.tableHeader}>
							<Text style={styles.strong}>Selo da Conciliação</Text>
						</View>
					</View>
					<View style={styles.row}>
						<View style={styles.colType1}>
							<Text style={styles.strong}>N° Nota Fiscal</Text>
						</View>
						<View style={styles.colType1}>
							<Text style={styles.strong}>Data Nota Fiscal</Text>
						</View>
						<View style={styles.colType1}>
							<Text style={styles.strong}>CNPJ</Text>
						</View>
					</View>
					<View style={styles.row}>
						<View style={styles.colType2}>
							<Text style={styles.strong}>{props.data.notaFiscal}</Text>
						</View>
						<View style={styles.colType2}>
							<Text style={styles.strong}>{moment(props.data.dataNotaFiscal).format('L HH:mm')}</Text>
						</View>
						<View style={styles.colType2}>
							<Text style={styles.strong}>{props.data.cnpj}</Text>
						</View>
					</View>
					<View style={styles.row}>
						<View style={styles.colType1}>
							<Text style={styles.strong}>Série</Text>
						</View>
						<View style={styles.colType1}>
							<Text style={styles.strong}>N° Conciliação</Text>
						</View>
						<View style={styles.colType1}>
							<Text style={styles.strong}>Data Conciliação</Text>
						</View>
					</View>
					<View style={styles.row}>
						<View style={styles.colType2}>
							<Text style={styles.strong}>{props.data.serie}</Text>
						</View>
						<View style={styles.colType2}>
							<Text style={styles.strong}>{props.data.numeroConciliacao}</Text>
						</View>
						<View style={styles.colType2}>
							<Text style={styles.strong}>{moment(props.data.dataConciliacao).format('L')}</Text>
						</View>
					</View>
					<View style={styles.row}>
						<View style={styles.colType1}>
							<Text style={styles.strong}>Fornecedor</Text>
						</View>
					</View>
					<View style={styles.row}>
						<View style={styles.tableFooter}>
							<Text style={styles.fornecedor}>{props.data.fornecedor}</Text>
						</View>
					</View>
				</View>
				<View style={styles.footer}>
					<View style={styles.spanFooter}>
						<Text style={styles.textFooter}>Prezado Fornecedor imprima e anexe este selo à nota fiscal que será entregue junto a mercadoria. Sem esse documento o Centro de Distribuição não esta autorizado a receber o pedido.</Text>
					</View>
				</View>
			</View>
		</Page>
	</Document >
);


export default ConciliationSeal;
//ReactPDF.render(<ConciliationSeal />);
